import * as React from 'react';
import { ArrowDownS16, ArrowUpS16 } from '@cian/ui-kit/icons';
import { Header3 } from '@cian/ui-kit/typography';

import * as styles from './Collapse.css';

interface ICollapseProps {
  title: string;
  children: React.ReactNode;
  isOpen: boolean;
  onClick(): void;
}

export const Collapse = ({ isOpen, title, children, onClick }: ICollapseProps) => {
  return (
    <>
      <div className={styles['title']} onClick={onClick}>
        <Header3 color="primary_100" userSelect="none">
          {title}
        </Header3>

        <span className={styles['icon-wrapper']}>
          {isOpen && <ArrowUpS16 color="primary_100" />}
          {!isOpen && <ArrowDownS16 color="primary_100" />}
        </span>
      </div>

      {isOpen && children}
    </>
  );
};
